//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthClient {
    constructor(private token: string) {
    }

    transformHttpRequestOptions(options: RequestInit): Promise<RequestInit> {
        options.mode = 'cors';
        if (options.headers && this.token) {
            options.headers = {
                Authorization: `Bearer ${this.token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }

        return Promise.resolve(options);
    }
}

export class AuthorizedApiBase {

    protected constructor(private authClient: AuthClient) {
    }

    protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
        return this.authClient ? this.authClient.transformHttpRequestOptions(options) : Promise.resolve(options);
    };
}

export class WorkshopsApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    search(body: WorkshopSearchRequest | undefined): Promise<Workshop[]> {
        let url_ = this.baseUrl + "/api/v1/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Workshop[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Workshop[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workshop[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSearchSuggestions(body: WorkshopSearchSuggestionRequest | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/search/suggestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSearchSuggestions(_response);
        });
    }

    protected processGetSearchSuggestions(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSearchSuggestionsWithData(body: WorkshopSearchSuggestionRequest | undefined): Promise<WorkshopInformation[]> {
        let url_ = this.baseUrl + "/api/v1/search/suggestionswithdata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSearchSuggestionsWithData(_response);
        });
    }

    protected processGetSearchSuggestionsWithData(response: Response): Promise<WorkshopInformation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkshopInformation[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkshopInformation[]>(null as any);
    }

    /**
     * @param ids (optional) A comma separated list of workshop ids, eg. SE010006,SE010007.
     * @param geocodePrecision (optional) How accurate the position is.
     * @param code (optional) The workshop code, eg. 010006.
     * @param name (optional) Name of the workshop.
     * @param street (optional) Street name of the workshop.
     * @param countryCode (optional) Two digit ISO 3166-2 country code of the workshop location.
    Supported country codes: FI, SE, NO, DK.
     * @param city (optional) City of the workshop.
     * @param postalCode (optional) Postal code for the workshop.
     * @param glassWebAddress (optional) Website address for the glass partner.
     * @param modifiedAfter (optional) Workshops that has been updated later than queried date.
    Should be specified in ISO 8601 date and time format, eg. 2018-08-20T11:47:44+01:00.
     * @return OK
     */
    getWorkshops(ids: string | undefined, geocodePrecision: GeocodePrecision | undefined, code: string | undefined, name: string | undefined, street: string | undefined, countryCode: string | undefined, city: string | undefined, postalCode: string | undefined, glassWebAddress: string | undefined, modifiedAfter: string | undefined): Promise<Workshop[]> {
        let url_ = this.baseUrl + "/api/v1/workshops?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            url_ += "Ids=" + encodeURIComponent("" + ids) + "&";
        if (geocodePrecision === null)
            throw new globalThis.Error("The parameter 'geocodePrecision' cannot be null.");
        else if (geocodePrecision !== undefined)
            url_ += "GeocodePrecision=" + encodeURIComponent("" + geocodePrecision) + "&";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (street === null)
            throw new globalThis.Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (countryCode === null)
            throw new globalThis.Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (city === null)
            throw new globalThis.Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (postalCode === null)
            throw new globalThis.Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "PostalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (glassWebAddress === null)
            throw new globalThis.Error("The parameter 'glassWebAddress' cannot be null.");
        else if (glassWebAddress !== undefined)
            url_ += "GlassWebAddress=" + encodeURIComponent("" + glassWebAddress) + "&";
        if (modifiedAfter === null)
            throw new globalThis.Error("The parameter 'modifiedAfter' cannot be null.");
        else if (modifiedAfter !== undefined)
            url_ += "ModifiedAfter=" + encodeURIComponent("" + modifiedAfter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkshops(_response);
        });
    }

    protected processGetWorkshops(response: Response): Promise<Workshop[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Workshop[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workshop[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    create(body: Workshop | undefined): Promise<Workshop> {
        let url_ = this.baseUrl + "/api/v1/workshops";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<Workshop> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Workshop;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workshop>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    update(body: WorkshopUpdateRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/workshops";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getById(id: string): Promise<Workshop> {
        let url_ = this.baseUrl + "/api/v1/workshops/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<Workshop> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Workshop;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Workshop>(null as any);
    }

    /**
     * @return No Content
     */
    deleteById(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/workshops/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteById(_response);
        });
    }

    protected processDeleteById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    disableCustomerService(id: string, body: DisableCustomerServicesRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/workshops/{id}/disablecustomerservice";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDisableCustomerService(_response);
        });
    }

    protected processDisableCustomerService(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param countryCode Two digit ISO 3166-2 country code of the workshop location.
    Supported country codes: FI, SE.
     * @return OK
     */
    getWorkshopContacts(countryCode: string): Promise<WorkshopContacts[]> {
        let url_ = this.baseUrl + "/api/v1/workshops/workshopcontacts?";
        if (countryCode === undefined || countryCode === null)
            throw new globalThis.Error("The parameter 'countryCode' must be defined and cannot be null.");
        else
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkshopContacts(_response);
        });
    }

    protected processGetWorkshopContacts(response: Response): Promise<WorkshopContacts[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkshopContacts[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkshopContacts[]>(null as any);
    }

    /**
     * @param workshopId (optional) 
     * @return OK
     */
    getWorkshopUpdatesByWorkshopId(workshopId: string | undefined): Promise<WorkshopUpdate[]> {
        let url_ = this.baseUrl + "/api/v1/workshopupdates?";
        if (workshopId === null)
            throw new globalThis.Error("The parameter 'workshopId' cannot be null.");
        else if (workshopId !== undefined)
            url_ += "workshopId=" + encodeURIComponent("" + workshopId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkshopUpdatesByWorkshopId(_response);
        });
    }

    protected processGetWorkshopUpdatesByWorkshopId(response: Response): Promise<WorkshopUpdate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkshopUpdate[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkshopUpdate[]>(null as any);
    }
}

export interface ContactPerson {
    /** Guid identifier for the entity. */
    id: string;
    /** Name of the entity. */
    name: string;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface ContractPrioritySearchInput {
    contractTypes?: ContractType[] | undefined;
    priorityTypes?: PriorityType[] | undefined;
    target?: ContractPrioritySearchTarget;
}

export enum ContractPrioritySearchTarget {
    WorkshopServiceRating = "WorkshopServiceRating",
    ManufacturerRating = "ManufacturerRating",
}

export enum ContractType {
    NotDecided = "NotDecided",
    A = "A",
    B = "B",
    C = "C",
    G = "G",
    X = "X",
}

export interface CustomerService {
    /** Guid identifier for the entity. */
    id: string;
    serviceType: CustomerServiceType;
    rentalCarBrand?: string | undefined;
    email?: string | undefined;
    externalId?: string | undefined;
    disabledStartDate?: string | undefined;
    disabledEndDate?: string | undefined;
}

export enum CustomerServiceType {
    Unspecified = "Unspecified",
    PreInspection = "PreInspection",
    RentalCarCentral = "RentalCarCentral",
    RentalCarLocal = "RentalCarLocal",
    RentalCarOwner = "RentalCarOwner",
    PhotoInspection = "PhotoInspection",
    WorkshopLetter = "WorkshopLetter",
    GlassPhotoInspection = "GlassPhotoInspection",
}

export interface DisableCustomerServicesRequest {
    customerServiceType: CustomerServiceType;
    startDate?: string | undefined;
    endDate?: string | undefined;
}

export enum GeocodePrecision {
    Unknown = "Unknown",
    CountryCentroid = "CountryCentroid",
    RegionCentroid = "RegionCentroid",
    Manual = "Manual",
    CityCentroid = "CityCentroid",
    PostcodeCentroid = "PostcodeCentroid",
    StreetLevel = "StreetLevel",
    InterpolatedOrTrueRooftop = "InterpolatedOrTrueRooftop",
}

export interface Manufacturer {
    code?: string | undefined;
    internationalManufacturerCode?: string | undefined;
    name?: string | undefined;
}

export interface ManufacturerRating {
    /** Guid identifier for the entity. */
    id: string;
    /** Name of the entity. */
    name: string;
    /** National manufacturer code (for ex. from swedish VTR) */
    code?: string | undefined;
    /** International, global and unique to Partner Directory manufacturer code */
    internationalManufacturerCode?: string | undefined;
    contractType: ContractType;
    priorityType: PriorityType;
    /** If the workshop for the current brand has a steering campaign and should be ranked higher. */
    steeringCampaign: boolean;
    /** Can this workshop accept towed cars of this manufacturer */
    excludeForTowers: boolean;
}

export enum PriorityType {
    NotPrioritized = "NotPrioritized",
    Prio1 = "Prio1",
    Prio2 = "Prio2",
    Prio3 = "Prio3",
    Prio4 = "Prio4",
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface PropertyDifference {
    propertyName?: string | undefined;
    newValue?: string | undefined;
    previousValue?: string | undefined;
}

export interface ValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export interface Workshop {
    /** The workshop unique identifier, should be built from Workshops.Entities.Workshop.CountryCode + Workshops.Entities.Workshop.Code. */
    id: string;
    name: string;
    /** Two digit ISO 3166-2 country code of the workshop.
Supported country codes: FI, SE, NO and DK. */
    countryCode: string;
    /** Country specific id commonly referred to as Code. */
    code: string;
    /** Organization number, aka registration or company number. */
    organizationNumber?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    towingEmail?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    /** Latitude position of the workshop in WGS84. */
    latitude?: number;
    /** Longitude position of the workshop in WGS84. */
    longitude?: number;
    geocodePrecision: GeocodePrecision;
    /** Preferred workshop, meets high standards. */
    isIfCertified: boolean;
    cabasId?: string | undefined;
    /** MaxHeight in millimeters of the vehicle that the workshop can handle.
Primary for paint boxes, but less used since most workshops solves it in some way. */
    maxHeight?: number | undefined;
    contactPerson?: ContactPerson;
    /** User id of the If employee responsible for the workshop. */
    responsiblePersonUserId?: string | undefined;
    /** User id of the If technician contact for the workshop. */
    surveyorUserId?: string | undefined;
    /** Ratings for all the services provided by the workshop. */
    workshopServiceRatings?: WorkshopServiceRating[] | undefined;
    /** Specific customer services provided by the workshop. */
    customerServices?: CustomerService[] | undefined;
    /** First date when the workshop was registered in the system. */
    dateCreated?: string | undefined;
    /** Date when the workshop had some information updated in the system. */
    dateModified?: string | undefined;
    /** A list of national manufacturer codes (vehicle brand codes) for whom the workshop cannot receive customers for. */
    excludeCustomerReceptionForManufacturerCodes?: string[] | undefined;
    /** A list of international manufacturer codes (vehicle brand codes) for whom the workshop cannot receive customers for. */
    excludeCustomerReceptionForInternationalManufacturerCodes?: string[] | undefined;
    /** Towing companies, eg Viking, should not be able to leave vehicles
to those workshops that has this flag set. */
    excludeForTowers: boolean;
    /** Website address for the glass partner */
    glassWebAddress?: string | undefined;
    /** Indicates if this workshop is an insurance retailer, which means that they somehow sells if Insurances
(or branded insurances with If as a insurance provider) in their dealer operations */
    isInsuranceRetailer?: boolean;
}

export interface WorkshopContacts {
    contactPersonEmail?: string | undefined;
    workshopEmail?: string | undefined;
    surveyorUserId?: string | undefined;
    responsiblePersonUserId?: string | undefined;
    connectedWorkshopId?: string | undefined;
    connectedWorkshopCode?: string | undefined;
}

export interface WorkshopInformation {
    /** The Id which should be built from CountryCode + Code. */
    id?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    glassWebAddress?: string | undefined;
}

export enum WorkshopSearchFilter {
    None = "None",
    Id = "Id",
    Name = "Name",
    Code = "Code",
    Street = "Street",
    PostalCode = "PostalCode",
    City = "City",
    ContactPerson = "ContactPerson",
    ResponsiblePerson = "ResponsiblePerson",
    SurveyorUser = "SurveyorUser",
}

export interface WorkshopSearchRequest {
    /** A workshop name, code, ID, address or any of the Workshops.Api.Models.WorkshopSearchRequest.Filters. */
    query?: string | undefined;
    /** Filters for the Workshops.Api.Models.WorkshopSearchRequest.Query. */
    filters?: WorkshopSearchFilter[] | undefined;
    /** Two digit ISO 3166-2 country code of the workshop location.
Supported country codes: FI, SE. */
    countryCode: string;
    /** A list of Workshops.Entities.Enums.WorkshopServiceType to search for. */
    workshopServiceTypes?: WorkshopServiceType[] | undefined;
    /** A list of Workshops.Entities.Manufacturer to search for. */
    manufacturers?: Manufacturer[] | undefined;
    contractPriorityInput?: ContractPrioritySearchInput;
    /** Indication whether the workshop handles all brands or only some specific manufacturers. */
    allManufacturers: boolean;
}

export interface WorkshopSearchSuggestionRequest {
    /** A workshop name, code, ID or address. */
    query: string;
    /** Two digit ISO 3166-2 country code of the workshop location.
Supported country codes: FI, SE. */
    countryCode: string;
    filter?: WorkshopSearchFilter;
}

export interface WorkshopServiceRating {
    /** Guid identifier for the entity. */
    id: string;
    serviceType: WorkshopServiceType;
    contractType: ContractType;
    priorityType: PriorityType;
    /** Does the workshop handle all brands or does it only handle specific brands
specified in the Workshops.Entities.WorkshopServiceRating.ManufacturerRatings. */
    allManufacturers: boolean;
    /** Can this workshop accept towed cars that need this type of service
specified in the Workshops.Entities.WorkshopServiceRating.ExcludeForTowers. */
    excludeForTowers: boolean;
    /** Specific ratings for each manufacturer(brand) handled by the workshop. */
    manufacturerRatings?: ManufacturerRating[] | undefined;
}

export enum WorkshopServiceType {
    Atv = "Atv",
    Body = "Body",
    Camper = "Camper",
    Caravan = "Caravan",
    Glass = "Glass",
    HeavyGlass = "HeavyGlass",
    Mc = "Mc",
    Moped = "Moped",
    MopedCar = "MopedCar",
    Service = "Service",
    Snowmobile = "Snowmobile",
    Trailer = "Trailer",
    VintageVehicle = "VintageVehicle",
    CashPayment = "CashPayment",
    SmallDentRepair = "SmallDentRepair",
    HeavyTrailer = "HeavyTrailer",
    TruckBody = "TruckBody",
    TruckService = "TruckService",
    BusBody = "BusBody",
    BusService = "BusService",
    Construction = "Construction",
    AuxiliaryEquipment = "AuxiliaryEquipment",
    Agricultural = "Agricultural",
    Forestry = "Forestry",
    ElectricVehicle = "ElectricVehicle",
    Sanitation = "Sanitation",
    MopedCarService = "MopedCarService",
    BodyFastLane = "BodyFastLane",
}

export interface WorkshopUpdate {
    description: string | undefined;
    dateUtc?: string;
    userIdentity: string | undefined;
    workshop: Workshop;
    propertyDifferences?: PropertyDifference[] | undefined;
}

export interface WorkshopUpdateRequest {
    /** A user description of the reason and/or the updated Workshops.Api.Models.WorkshopUpdateRequest.Workshop properties. */
    userDescription: string;
    workshop: Workshop;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}